import { FILTER_QUERY_VALUE_TYPES } from '@frontend/api';

/**
 * Configuration for input field widths based on semantic value types.
 * These widths are designed to accommodate the expected number of digits
 * for each type of input while maintaining good UX.
 */
export const INPUT_WIDTH_CONFIG = {
  // Count inputs (e.g., "appears X times") - supports up to 4 digits (9999)
  COUNT: 10,

  // Distance inputs (inches/millimeters) - supports up to 6 digits (999.999)
  [FILTER_QUERY_VALUE_TYPES.DISTANCE]: 12,

  // Angle inputs (degrees) - supports up to 6 digits (360.000)
  [FILTER_QUERY_VALUE_TYPES.ANGLE]: 14,

  // Generic number inputs - supports up to 6 digits (999.999)
  [FILTER_QUERY_VALUE_TYPES.NUMBER]: 14,
} as const;

/**
 * Get the appropriate width for a numeric input based on its semantic type.
 *
 * @param valueType - The semantic type of the value (e.g., 'distance', 'angle', 'number')
 * @param isCountQuery - Whether this is a count query input
 * @returns The recommended width in Chakra UI units
 */
export const getInputWidth = (
  valueType?: string,
  isCountQuery = false,
): number => {
  if (isCountQuery) {
    return INPUT_WIDTH_CONFIG.COUNT;
  }

  if (valueType && valueType in INPUT_WIDTH_CONFIG) {
    return INPUT_WIDTH_CONFIG[valueType as keyof typeof INPUT_WIDTH_CONFIG];
  }

  // Default to generic number width
  return INPUT_WIDTH_CONFIG[FILTER_QUERY_VALUE_TYPES.NUMBER];
};
